import Live2Sc from "../../components/live2/sc/Live2Sc";
import {useSocket} from "../../helpers/socket";

const Live2SCPage = () => {
    const {socket} = useSocket({});
    return <Live2Sc socket={socket}/>
}
export default Live2SCPage;